import { render } from "./ReviewsComponent.vue?vue&type=template&id=10253c3d&scoped=true&ts=true"
import script from "./ReviewsComponent.vue?vue&type=script&lang=ts"
export * from "./ReviewsComponent.vue?vue&type=script&lang=ts"

import "./ReviewsComponent.vue?vue&type=style&index=0&id=10253c3d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10253c3d"]])

export default __exports__